<section class="profile-data">
  <div class="profile-data_title">
    <h5 *ngIf="notification">{{ notification }}</h5>
  </div>
  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field hintLabel="* Обязательно" appearance="outline">
      <mat-label>Имя</mat-label>
      <input matInput #firstName placeholder="Имя" formControlName="firstName">
      <mat-error *ngIf="form.controls.firstName.invalid">* Обязательное поле. Не менее 3 и не более 35 символов. Не должно содержать цифры.</mat-error>
    </mat-form-field>

    <mat-form-field hintLabel="" appearance="outline">
      <mat-label>Отчество</mat-label>
      <input matInput #middleName placeholder="Отчество" formControlName="middleName">
      <mat-error *ngIf="form.controls.middleName.invalid">Не менее 2 и не более 35 символов. Не должно содержать цифры.</mat-error>
    </mat-form-field>

    <mat-form-field hintLabel="* Обязательно" appearance="outline">
      <mat-label>Фамилия</mat-label>
      <input matInput #lastName placeholder="Фамилия" formControlName="lastName">
      <mat-error *ngIf="form.controls.lastName.invalid">* Обязательное поле. Не менее 4 и не более 35 символов. Не должно содержать цифры.</mat-error>
    </mat-form-field>

    <mat-form-field hintLabel="* Обязательно. Пример формата example@mail.ru" appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput #email placeholder="email" formControlName="email" type="email">
      <mat-error *ngIf="form.controls.email.invalid">* Обязательное поле. Пример формата example@mail.ru</mat-error>
    </mat-form-field>

    <mat-form-field hintLabel="Пример формата 87776665544" appearance="outline">
      <mat-label>Телефон</mat-label>
      <input matInput #phone placeholder="телефон" formControlName="phone" type="number">
      <mat-error *ngIf="form.controls.phone.invalid">Некоректный телефон. Пример формата 87776665544</mat-error>
    </mat-form-field>

    <mat-checkbox formControlName="confirmDataUsage">Даю согласие на обработку персональных данных</mat-checkbox>

    <hr>
    <button
      class="form__button"
      mat-raised-button matTooltip="Сохранить"
      matTooltipPosition="above"
      color="primary"
      [disabled]="!form.valid">Сохранить</button>
  </form>

  <div class="profile-data_ex-info">
    <p>Вопросы по whatsapp +77077047775</p>
  </div>
</section>


<ng-template #confirmEmail>
  <div class="modal-header" mat-dialog-title><mat-icon (click)="closeDialog()">close</mat-icon></div>
  <mat-dialog-content>
    Для завершения регистрации, пожалуйста,
    <br>
    подтвердите адрес своей электронной почты.
    <br><br>
    Вам выслано письмо на адрес 
    <br>
    <b>{{ form?.value.email }}</b>
  </mat-dialog-content>
</ng-template>